import clsx from "clsx"
import { ImageIcon, UserIcon } from "../assets/icons"
import React from "react"
import Shimmer from "./Shimmer"
import { ArrowDown } from "lucide-react";

export const GraphSkeleton = ({ className }) => {
  return (
    <div className={clsx(className, "flex gap-3 custom-pulse")}>
      <div className="bg-shark-200 h-full w-full card-xs-border" />
      <div className="bg-shark-200 h-full w-full card-xs-border" />
      <div className="bg-shark-200 h-full w-full card-xs-border" />
      <div className="bg-shark-200 h-full w-full card-xs-border" />
    </div>
  )
}

export const ImageSkeleton = ({ className }) => {
  return (
    <div
      className={clsx(
        className,
        "custom-pulse flex justify-center items-center bg-shark-100"
      )}>
      <ImageIcon className="shark-300-svg" />
    </div>
  )
}

export const IconSkeleton = ({ className }) => {
  return (
    <div
      className={clsx(
        className,
        "custom-pulse bg-shark-50 rounded-full self-center flex items-center justify-center"
      )}>
      <UserIcon className="shark-300-svg w-[2.5rem] h-[2.5rem]" />
    </div>
  )
}

export const TextSkeleton = ({ className }) => {
  return (
    <div
      className={clsx(
        className,
        "custom-pulse bg-shark-100 rounded-[0.4rem] h-4"
      )}>
      <Shimmer />
    </div>
  )
}

export const ChildrenSkeleton = ({ className, children }) => {
  return (
    <div className={clsx(className, "custom-pulse bg-shark-100")}>
      {children}
    </div>
  )
}

export const FileSkeleton = ({ className }) => {
  return (
    <div className={clsx("flex gap-4 justify-between", className)}>
      <DefaultSkeleton className="h-12 w-12 rounded-xl" />
      <div className="flex flex-col flex-1 justify-center gap-3">
        <TextSkeleton className="h-14 w-1/2" />
      </div>
      <ArrowDown className="text-white bg-accumin-secondary-magenta rounded-xl p-[2px] border-0 w-4 h-4 my-auto"/>
    </div>
  )
}

export const ListItemSkeleton = ({ className }) => {
  return (
    <div className={clsx("flex justify-between gap-4 items-center bg-white-lilac-50 my-2 rounded-xl p-2", className)}>
      <DefaultSkeleton className="w-12 h-12 rounded-xl m-1" />
      <div className="flex flex-col flex-1 justify-center gap-1">
        <TextSkeleton className="w-1/3" />
        <TextSkeleton className="w-2/3" />
      </div>
    </div>
  )
}

export const DefaultSkeleton = ({ className }) => {
  return (
    <div className={clsx("custom-pulse bg-shark-100", className)}>
      <Shimmer />
    </div>
  )
}

export default DefaultSkeleton
